function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.996 7.74c.398 0 .75-.328.75-.752.023-.21-.07-.398-.258-.562L7.505 1.164A.779.779 0 007.012 1c-.164 0-.351.023-.515.188L.485 6.426a.762.762 0 00-.234.562c0 .422.328.753.75.753h.75V11.5c0 .827.672 1.5 1.5 1.5h7.511c.832 0 1.505-.675 1.5-1.507l-.016-3.755h.75v.003zM6.25 5.876c0-.206.168-.375.375-.375h.75c.206 0 .375.169.375.375V7h1.125c.206 0 .375.169.375.375v.75a.376.376 0 01-.375.375H7.75v1.125a.376.376 0 01-.375.375h-.75a.376.376 0 01-.375-.375V8.5H5.126a.376.376 0 01-.375-.375v-.75c0-.206.168-.375.375-.375H6.25V5.875z",
  fill: "currentColor"
});

var SvgDiagnostic = function SvgDiagnostic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgDiagnostic;